import React from 'react'
import _ from 'lodash'
import checkit from 'lodash-checkit'
import { withTheme, withStyles } from 'material-ui/styles'
import PropTypes from 'prop-types'
import Tabs, { Tab } from 'material-ui/Tabs'

const styles = theme => ({
  tabRoot: {
    background: theme.palette.alternative.main,
    border: 0,
    color: theme.palette.primary.main,
    minWidth: '60px', //'fit-content',
    //maxWidth: '120px', //'fit-content',
    wordWrap: 'break-word',
    textAlign: 'left'
  },
  tabLabelContainer: {
    wordWrap: 'break-word',
    padding: '0 12px' // #58
  },
  tabsRoot: {
    background: theme.palette.alternative.main,
    color: theme.palette.primary.main,
    display: 'inline-block'
  },
  tabsButtonAuto: {
    flex: '0 0 25px' //was 56px
  },
  tabsFlexContainer: {
    margin: 'auto',
    marginLeft: 0 // #58
  },
  tabsScrollingContainer: {
    display: 'flex'
  }
})

const TabsComponent = props => {
  const {
    classes,
    // theme: { palette },
    history: { push, location: { pathname } },
    // match: { params: { id, form, section } },
    tabs
  } = props

  const path = `${pathname}`
    .split('/')
    .reduce(
      (p, c, i) =>
        `${p}${
          (i === 1 || i === 2) &&
          c !== '' &&
          c !== 'new' &&
          !checkit.isNumeric(c)
            ? `${c}/`
            : ''
        }`,
      '/'
    )

  return (
    <Tabs
      classes={{
        root: classes.tabsRoot,
        flexContainer: classes.tabsFlexContainer,
        scrollingContainer: classes.tabsScrollingContainer,
        buttonAuto: classes.tabsButtonAuto
      }}
      value={
        _.findIndex(tabs, ['path', path]) >= 0
          ? _.findIndex(tabs, ['path', path])
          : 0
      }
      indicatorColor="primary"
      textColor="secondary"
      scrollable
      centered
    >
      {tabs.map((t, i) => (
        <Tab
          classes={{
            root: classes.tabRoot,
            labelContainer: classes.tabLabelContainer
          }}
          key={t.id}
          label={t.label}
          onClick={() => push(`${t.path}?columnViewId=1`)}
        />
      ))}
    </Tabs>
  )
}

TabsComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
}

export default withStyles(styles)(withTheme()(TabsComponent))



// WEBPACK FOOTER //
// ./src/core/components/Tabs.js